import './styles.css';
import { initializeAvatar } from './avatar.js';
import { initializeGreeting } from './chat.js';

document.querySelector('#year').textContent = new Date().getFullYear();
initializeGreeting();
initializeAvatar();

const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    }
  });
}, { threshold: 0.13 });

document.querySelectorAll('.reveal').forEach((element, index) => {
  element.style.transitionDelay = `${Math.min(index % 3, 2) * 90}ms`;
  observer.observe(element);
});

const header = document.querySelector('.site-header');
const updateHeader = () => header?.classList.toggle('is-scrolled', window.scrollY > 36);
window.addEventListener('scroll', updateHeader, { passive: true });
updateHeader();
